export const contactRequestsRoutes = [
  {
    path: '/contact-requests',
    name: 'ContactRequests',
    component: () =>
      import(
        /* webpackChunkName: "contactRequests" */ '@/views/Dashboard/ContactRequests/ContactRequests.vue'
      ),
  },
  {
    path: '/contact-requests/:id',
    name: 'ContactRequestDetail',
    component: () =>
      import(
        /* webpackChunkName: "contactRequestsDetail" */ '@/views/Dashboard/ContactRequests/ContactRequestDetail.vue'
      ),
  },
];
